import apiSlice from '../api/api.slice';
import { ICategory, IGetCategoriesParams } from './category';

const category = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getCategories: builder.query<ICategory[], IGetCategoriesParams>({
      query: (params) => ({
        url: '/api/v1/category/getCategories',
        method: 'GET',
        params,
      }),
      transformResponse: (response: { categories: ICategory[] }) =>
        response.categories,
    }),
  }),
});

apiSlice.enhanceEndpoints({
  addTagTypes: ['category'],
  endpoints: {
    providesTags: ['category'],
  },
});

export const { useGetCategoriesQuery } = category;
